import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import { DataContext } from "../../DataContext"; // Import the context
import Banner from "../../component/Banner/Banner";
import BottomSubscribe from "../../component/BottomSubscribe";
import Perks from "../../component/Perks/Perks";
import BikeShowcase from "../../component/BikeShowcase";
import HowToUseMyByk from "../../component/HowToUseMyByk/HowToUseMyByk";
import SwapYourBike from "../../component/SwapYourBike/SwapYourBike";
import HereOutStories from "../../component/HereOutStories";
import MeetOurFounder from "../../component/MeetOurFounder/MeetOurFounder";
import HereToMakeItEasy from "../../component/HereToMakeItEasy/HereToMakeItEasy";
import SubscribeNow from "../../component/SubscribeNow/SubscribeNow";
import OurPromise from "../../component/OurPromise/OurPromise";
import Chatbot from "../../component/Chatbot/Chatbot";

const Home = () => {
  const { isValidParam } = useContext(DataContext);  
  return (
    <section>
      <Helmet>
        <title>MYBYK | Landing Page</title>
        <meta name="description" content="My Byk Landing Page Description" />
      </Helmet>
      <Banner />
      <Perks />

      <BikeShowcase />
      <HowToUseMyByk />
      <SwapYourBike />
      <HereOutStories />
      <MeetOurFounder />      
      {isValidParam && <SubscribeNow />}
      <OurPromise />
      <HereToMakeItEasy />     
      {isValidParam && <BottomSubscribe />}
      <Chatbot/>  
    </section>
  );
};

export default Home;
